import axios from "axios";
import { useEffect, useRef, useState } from "react";
// import { useFrfrView } from "../hooks/useFrfrView";
import { useFrfrViewMultimode } from "../hooks/useFrfrViewMultimode";
import { dmd_utils } from "../utils/frfr-dmd-utils";
import { js_utils } from "../utils/frfr-js-utils";
import { rapidozi_dummysmarty_utils } from "../utils/frfr-rapidozi-dummy-utils";
import { frfr_res_utils } from "../utils/frfr-res-utils";
import { ACCEPT_FILE_TYPES_IMG_JPG_PNG } from "../utils/frfr-string-constants";
import { _zzyourmap_ajax, _zzyourmap_urlLib } from "../utils/zz/zz-yourmap-ajax-adapter";
import { _zzyourmap_prepare_entbox_for_submit_image_library_meta, _zzyourmap_formDefinition_formPart_editing, _zzyourmap_formDefinition_image_library_meta, _zzyourmap_preset_image_library_meta } from "../utils/zz/zz-yourmap-admin-form-utils";
import { _zzyourmap_prepare_image_library_entities } from "../utils/zz/zz-yourmap-image-utils";
import { _zzyourmap_lib_image_library_tags_default } from "../utils/zz/zz-yourmap-data-keys-and-values-lib";
import FormFieldGenerator from "./FormFieldGenerator";
import FormGenerator from "./FormGenerator";
import Komentar from "./Komentar";
import UniBtn from "./UniBtn";
import UniImage from "./UniImage";
import UniPaginationMuiTablePagination from "./UniPaginationMuiTablePagination";
import UniSpinnerClassic from "./UniSpinnerClassic";
import { tags_utils } from "../utils/frfr-tags-utils";


//
const _prepare_img_meta_for_edit = (item) => {
  const editing_entity = {
    ..._zzyourmap_preset_image_library_meta,
  };
  if (item.id > 0) {
    editing_entity.id = item.id;
  }
  editing_entity.img_alt = js_utils.fix_always_string(item.img_alt);
  editing_entity.img_title = js_utils.fix_always_string(item.img_title);
  editing_entity.note = js_utils.fix_always_string(item.note);
  editing_entity.tags_csv = js_utils.fix_always_string(item.tags_csv);
  return editing_entity;
};


//
const FormEditMeta = (props) => {
  // const cbDialogSubmit = props.cbDialogSubmit;
  // const cbDialogCancel = props.cbDialogCancel;
  const {
    cbSubmitUpdateImageMeta,
    // cbDialogSubmit,
    cbDialogCancel,
    preview_src,
    tags_arr_all,
  } = props;
  /*
  const {
    // setUniModalPortableContent_3,
    // setUniModalPortableClose_3,
  } = props.appPack;
  */
  //
  let initialState;
  let formDefinition;
  let editMode = false;
  if (props.mode === 'EDIT') {
    editMode = true;
    initialState = props.editorData;
    formDefinition = [..._zzyourmap_formDefinition_formPart_editing, ..._zzyourmap_formDefinition_image_library_meta];
  } else {
    initialState = { ..._zzyourmap_preset_image_library_meta };
    formDefinition = _zzyourmap_formDefinition_image_library_meta;
  }
  // const [state, handleChange, setState] = useHandleInputChange(initialState);
  //
  // ----- image meta EDIT
  // const [formStateMeta, setFormStateMeta] = useState({ ..._zzyourmap_preset_image_library_meta });
  const [formStateMeta, setFormStateMeta] = useState(initialState);
  const handleChangeFormStateMeta = (e) => {
    const target = e.target;
    const name = target.name;
    const value = target.value;
    setFormStateMeta({
      ...formStateMeta,
      [name]: value
    });
  };
  //
  const _handleTagPick = (new_tag) => {
    setFormStateMeta(state => {
      if (js_utils.is_string_not_empty(new_tag) && !(new_tag.includes(',')) && !(new_tag.includes(';')) && !(new_tag.includes(' '))) {
        // let _new_tag = new_tag.trim().toLowerCase();
        // const tags_arr = js_utils.string_split_to_arr_but_exclude_empty(state.tags_csv, ',');
        let fixed_tag = tags_utils.fix_tag_lowercase(new_tag);
        const tags_arr = tags_utils.convert_tags_csv_to_tags_arr(state.tags_csv);
        if (tags_utils.is_tag_exist_in_tags_arr(tags_arr, fixed_tag)) {
          // skip duplicate
        } else {
          if (js_utils.is_string_not_empty(fixed_tag)) {
            const updated_tags_arr = [...tags_arr, fixed_tag];
            updated_tags_arr.sort();
            // const updated_tags_csv = updated_tags_arr.join(',');
            const updated_tags_csv = tags_utils.convert_tags_arr_to_tags_csv(updated_tags_arr);
            return {
              ...state,
              tags_csv: updated_tags_csv,
            };
          }
        }
      }
      // 
      return state; // return unchanged
    });
  };
  //
  const _handleTagsDelete = (target_tag) => {
    setFormStateMeta(state => {
      if (true) {
        const tags_arr = js_utils.string_split_to_arr_but_exclude_empty(state.tags_csv, ',')
        if (tags_arr.includes(target_tag)) {
          const updated_tags_arr = tags_arr.filter(tag => {
            if (tag === target_tag) {
              return false; // delete
            }
            return true; // all other stay
          });
          const updated_tags_csv = updated_tags_arr.join(',');
          return {
            ...state,
            tags_csv: updated_tags_csv,
          };
        }
      }
      // 
      return state; // return unchanged
    });
  };
  //
  return (
    <div className="unicompo-various-content">
      <div className="yourmap__image-library__form-image-meta">
        <h3 className="uu-mt-0">Edit image META information</h3>
        <div className="yourmap__image-library__add-new__preview">
          preview:
          <UniImage src={preview_src} extraClass="yourmap__theme__image-lib-preview" />
        </div>
        <div>
          <FormGenerator
            formDefinition={formDefinition}
            formState={formStateMeta}
            formErrors={{}}
            handleChange={handleChangeFormStateMeta}
          />
        </div>
        <div>
          <div className="yourmap__lib-tags uu-text-no-wrap">
            {/*
            Tags:
            <div className="uu-vector uu-vector--row uu-vector--wrap uu-gaps-m-4px">
              {
                js_utils.string_split_to_arr_but_exclude_empty(formStateMeta.tags_csv, ',').map(tag => {
                  return (
                    <div key={tag} className="yourmap__lib-tags__tag yourmap__lib-tags__tag--added">{tag}<i onClick={() => { _handleTagsDelete(tag) }} className="fa fa-times-circle" aria-hidden="true"></i></div>
                  );
                })
              }
            </div>
            */}
            Pick tags:
            <div className="uu-vector uu-vector--row uu-vector--wrap uu-gaps-m-4px">
              {
                tags_arr_all.map(tag => {
                  return (
                    <div key={tag} className="yourmap__lib-tags__tag yourmap__lib-tags__tag--pick" onClick={() => { _handleTagPick(tag) }}><i className="fa fa-plus" aria-hidden="true"></i>{tag}</div>
                  );
                })
              }
            </div>
          </div>
        </div>
        <div className="uu-gap-standalone-1rem"></div>
        <Komentar>
          <p>- Polje img_alt nije potrebno unositi za slike namenjene za map widget (mapa i markeri) jer ih widget svakako ignoriše. Ali može vam pomoći za snalaženje jer opisuje šta je na slici.</p>
          <p>- Polje img_title (Naslov slike) može eventualno zatrebati ako se slika bude koristila unutar teksta na blogu pa ispod nje da stoji naslov slike.</p>
          <p>- Tagovi u Image Library se korisite samo radi preglednosti i brzine snalaženja medju velikim brojem slika u Image Library a izvan toga nemaju značenje.</p>
        </Komentar>
        <div className="uu-gap-standalone-05rem"></div>
        <div className="uu-vector uu-vector-row uu-gaps-m-1rem">
          <UniBtn
            disabled={false}
            inline
            wide
            circle_EX
            i="fa fa-paper-plane"
            title="Submit"
            handleClick={() => {
              // cbDialogSubmit(state);
              const prepared_entbox = _zzyourmap_prepare_entbox_for_submit_image_library_meta(formStateMeta);
              if (editMode) { // EDIT
                // const payload = { of_id: state.of_id };
                const payload = { id: formStateMeta.id };
                // cbDialogSubmit(prepared_entbox, payload);
                console.log('image library SUBMIT', prepared_entbox, payload);
                cbSubmitUpdateImageMeta(prepared_entbox, payload);
              } else { // ADD
                // cbDialogSubmit(prepared_entbox);
              }
              // cbDialogCancel();
            }}
          />
          <UniBtn
            disabled={false}
            inline
            wide
            outline
            circle_EX
            i="fa fa-times"
            title="Cancel"
            handleClick={() => { cbDialogCancel(); }}
          />
        </div>
        <div className="uu-gap-standalone-1rem"></div>
      </div>
    </div>
  );
};


//
const ImageLibraryItem = (props) => {
  const {
    item,
    item_key,
    src,
    itemPack,
    tags_arr_all,
  } = props;
  const {
    enableSelectSingular,
    enableSelectMultiple,
    enableAdminFunc,
    isRecycleBin,
    _isRowSelected,
    _handleClickSelectRow,
    _handleClickDeleteImage,
    _handleClickUndeleteImage,
    cbSubmitUpdateImageMeta,
    setUniModalPortableContent_3,
    setUniModalPortableClose_3,
  } = itemPack;
  //
  let _is_item_selection_highlighted = false;
  const _is_item_selected = _isRowSelected(item_key);
  const _is_item_selected_singular = _isRowSelected(item_key, true);
  if (_is_item_selected === true || _is_item_selected_singular === true) {
    _is_item_selection_highlighted = true;
  }
  //
  return (
    <div className={"yourmap__image-library__item" + (_is_item_selection_highlighted ? " yourmap__image-library__item--selected" : "")}>
      <div className="yourmap__image-library__tail">
        <div className="yourmap__image-library__actions">
          <div className="uu-vector uu-vector-row uu-gaps-p-05rem uu-vector--items-center">
            {
              enableSelectSingular === true && (
                <div>
                  <label className="uniformcompo__label-wrapping-checkbox" htmlFor={'select_image_lib_item_singular'}>
                    <span className="label"></span>
                    <span className="uu-anyinput__control-container uniformcompo__checkbox-aura">
                      <input
                        type="radio"
                        name={'select_image_lib_item_singular'}
                        value={''}
                        checked={_is_item_selected_singular}
                        onChange={() => { _handleClickSelectRow(item_key, true); }}
                      />
                    </span>
                  </label>
                </div>
              )
            }
            {
              enableSelectMultiple === true && (
                <div>
                  <label className="uniformcompo__label-wrapping-checkbox" htmlFor={'select_image_lib_item'}>
                    <span className="uu-anyinput__control-container uniformcompo__checkbox-aura">
                      <input
                        type="checkbox"
                        name={'select_image_lib_item'}
                        readOnly={false}
                        disabled={false}
                        checked={_is_item_selected}
                        onChange={(e) => { _handleClickSelectRow(item_key); }}
                      />
                    </span>
                  </label>
                </div>
              )
            }
            <div>
              <UniBtn
                wide_NOT
                circle
                size={16}
                i="fa fa-pencil"
                title_NOT="EDIT"
                tooltip="EDIT META"
                themeCompoColorBlue
                handleClick={() => {
                  setUniModalPortableContent_3({
                    options: {
                      large: true,
                      zIndex: 22,
                    },
                    jsx: (
                      <>
                        <FormEditMeta
                          mode={'EDIT'}
                          editorData={_prepare_img_meta_for_edit(item)}
                          preview_src={src}
                          tags_arr_all={tags_arr_all}
                          cbDialogSubmit={cbSubmitUpdateImageMeta}
                          cbSubmitUpdateImageMeta={cbSubmitUpdateImageMeta}
                          cbDialogCancel={setUniModalPortableClose_3}
                        />
                      </>
                    ),
                  });
                }}
              />
            </div>
            {
              enableAdminFunc === true && (
                isRecycleBin === true ? (
                  <div>
                    <UniBtn
                      wide
                      circle
                      size={16}
                      i="fa fa-undo"
                      title="UNDELETE"
                      themeCompoColorGreen
                      handleClick={() => {
                        if (typeof _handleClickUndeleteImage === 'function') {
                          if (window.confirm('Are you sure you want to UNDELETE image?')) {
                            _handleClickUndeleteImage(item_key);
                          }
                        }
                      }}
                    />
                  </div>
                ) : (
                  <div>
                    <UniBtn
                      circle
                      size={16}
                      i="fa fa-trash"
                      themeCompoColorRed
                      extraClass="yourmap__theme__custom-btn-orange222"
                      handleClick={() => {
                        if (typeof _handleClickDeleteImage === 'function') {
                          if (window.confirm('Are you sure you want to delete image?')) {
                            _handleClickDeleteImage(item_key);
                          }
                        }
                      }}
                    />
                  </div>
                )
              )
            }
          </div>
          <div className="yourmap__image-library__details">
            <div><span>id:&nbsp;{item.id}</span>&nbsp;&nbsp;<a target="_blank" rel="noopener noreferrer" href={src} >{item.img_filename}</a></div>
            <div><b>img_alt</b>: {item.img_alt}</div>
            <div><b>img_title</b>: {item.img_title}</div>
            <div><b>tags_csv</b>: {item.tags_csv}</div>
          </div>
        </div>
      </div>
      <UniImage src={src} extraClass="yourmap__theme__image-lib-figure" />
    </div>
  );
};


//
const ImageLibraryView = (props) => {
  const {
    viewArgs,
    showDetails,
    tags_arr_all,
    tags_arr_used,
  } = props;
  const {
    _fetching,
    // _viewBlueprint,
    rowsData,
    cbOnSelectionChange,
    dataFreshness,
    cbOnSelectionChangeSingular,
  } = viewArgs;

  const _viewBlueprint = {
    general: {
      disableBlueprintCaching: false, // TODO
      selectAllSelectOnlyVisible: true, // TODO
      pagination_enabled: true, // TODO
      pagination_rowsPerPageInitial: 10, // TODO
    },
    row: {
      // rowKeyExtractor: blueprintRow.rowKeyExtractor,
    },
  };

  const {
    // data
    fetching,
    dataError,
    rowsFinalReadyArr, // TODO
    isZeroItemsFinalReadyArr,
    tableRowsArr, // TODO

    // filtering
    _handleChangeColumnFilterString,

    // sorting
    _getColumnSortedState,
    _handleClick_table_th_sort,

    // pagination
    paginationPack,

    // selection
    selectedAllRowsChecked,
    selectedRowsCount,
    _isRowSelected,
    _handleClickSelectRow,
    _handleClickSelectAllRows,
    _handleClickSelectReset,

    // utils
    blueprintError,
  } = useFrfrViewMultimode(_fetching, _viewBlueprint, rowsData, dataFreshness, cbOnSelectionChange, cbOnSelectionChangeSingular);


  let jsxSpinner = null;
  if (fetching) {
    jsxSpinner = (
      <UniSpinnerClassic />
    );
  }

  const itemPack = {
    enableSelectSingular: props.enableSelectSingular,
    enableSelectMultiple: props.enableSelectMultiple,
    enableAdminFunc: props.enableAdminFunc,
    isRecycleBin: props.isRecycleBin,
    _isRowSelected,
    _handleClickSelectRow,
    _handleClickDeleteImage: props._handleClickDeleteImage,
    _handleClickUndeleteImage: props._handleClickUndeleteImage,
    cbSubmitUpdateImageMeta: props.cbSubmitUpdateImageMeta,
    setUniModalPortableContent_3: props.setUniModalPortableContent_3,
    setUniModalPortableClose_3: props.setUniModalPortableClose_3,
  }

  return (
    <>
      <div className="yourmap__image-library__view">
        {jsxSpinner}
        <div className={showDetails === true ? "yourmap__image-library__list-details uu-vector uu-vector--col uu-vector--forced uu-gaps-p-4px uu-text-nowrap" : "yourmap__grid yourmap__grid--gaps-1rem uu-max-w-800px uu-min-h-200px"}>
          {
            fetching !== true && (
              rowsFinalReadyArr.map((item, index) => {
                const item_key = item.id;
                const src = item.img_url_full;
                return (
                  <div key={item_key} className="xi">
                    <ImageLibraryItem
                      item_key={item_key}
                      src={src}
                      item={item}
                      itemPack={itemPack}
                      tags_arr_all={tags_arr_all}
                    />
                  </div>
                );
              })
            )
          }
        </div>

        <div className="frfr-table-generator__pagination-container">
          <UniPaginationMuiTablePagination paginationPack={paginationPack} />
        </div>
      </div>
    </>
  );
};


//
const FormAddToImageLibrary = (props) => {
  console.log('test render');
  const inputFileRef = useRef(null);
  const {
    modeAdd,
    setModeAdd,
    uploadFetching,
    setUploadFetching,
    refresh,
    tags_arr_all,
  } = props;
  const [localFreshness, setLocalFreshness] = useState(0);
  const [imgSrcBlob, setImgSrcBlob] = useState(null); // image preview
  const handleFileChange = (e) => {
    // just to force component to render when file input change
    setLocalFreshness(localFreshness => localFreshness + 1);
  };
  const handleInputFileChange = (e) => {
    // just to force component to render when file input change
    setLocalFreshness(localFreshness => localFreshness + 1);
    //
    // ovo je poseabn handler samo za onChange na input type="file" polju
    // console.log('handleInputFileChange(e) ');
    // console.log(e);
    const target = e.target;
    // posto input polje za fajl moze da primi vise fajlova...
    // console.log(target.files.length);
    // let dom_el = inputFileRef.current; // reference to a DOM input file element
    // if (dom_el) {
    if (target) {
      // let target = dom_el;
      const files = target.files;
      console.log(files);
      console.log(files.length);
      if (files.length > 0) {
        const selectedFile = files[0];
        // const selectedFile = target.files[0];
        if (selectedFile) { // znaci da je odabran najmanje jedan fajl
          const reader = new FileReader(); // napravi novu instancu klase FileReader
          // reader.onload = function (e) {
          const handleLoad = (e) => {
            console.log('--- FileReader .onload (event "load")');
            console.log(e);
            console.log('uspesno se zavrsilo ucitavanje fajla');
            const blob = reader.result; // dobili smo blob ucitanog fajla slike
            // upisujemo gotov blob u nas state
            // setImageBlob(blob);
            setImgSrcBlob(blob);
            /*
            if (e.target && e.target.result) {
              const raw = e.target.result;
      console.log('typeof e.target.result', typeof e.target.result);
      console.log('e.target.result', raw);
      try {

      } catch (err) {
        console.log('error catch while ______ file', err);
              }
            }
      */
          };
          reader.addEventListener("load", handleLoad);
          reader.readAsDataURL(selectedFile); // zapocinje citanje fajla u formatu slike koji moze da se koristi u src od slike
        }
      }
    }
  };
  const clearFileInputField = () => {
    if (inputFileRef.current) {
      inputFileRef.current.value = ''; // This clears the selected file
    }
  };
  //
  const _submit_file = (e) => {
    // Not real submit form for field upload. Just click on button to se selected files.
    setUploadFetching(true);
    console.log('_submit_file(e) ');
    console.log(e);
    // let target = e.target;
    let dom_el = inputFileRef.current; // reference to a DOM input file element
    if (dom_el) {
      console.log('ref dom_el', dom_el);
      /*
      FileList {0: File, length: 1}
      {
        0: File
      lastModified: 1764023846955
      lastModifiedDate: Mon Nov 24 2025 23:37:26 GMT+0100 (Central European Standard Time)
      [[Prototype]]: Object
      name: "3D PRINTING 2025-11-24_233718.jpg"
      size: 284002
      type: "image/jpeg"
      webkitRelativePath: ""
      [[Prototype]]: File
      length: 1
      [[Prototype]]: FileList
      }
      */
      let target = dom_el;
      let files = target.files;
      console.log(files);
      console.log(files.length);
      if (files.length > 0) {
        let selectedFile = files[0];
        if (selectedFile) {
          const filename = selectedFile.name;
          const _extract_filename_extension = (filename) => {
            // filename_extension: '.' + _filename_exploded[_filename_exploded.length - 1],
            const _filename_exploded = filename.split('.');
            if (_filename_exploded.length > 1) {
              const filename_extension = '.' + _filename_exploded[_filename_exploded.length - 1];
              return filename_extension;
            } else {
              return null;
            }
          };
          const _result = {
            readme: '* answer of function handle submit file',
            filename: filename,
            filename_extension: _extract_filename_extension(filename),
          };
          //
          //
          /*
          To send multipart form data with Axios, including files and other fields, the FormData API is utilized. This method allows the construction of a request body that can contain various types of data, suitable for multipart/form-data encoding.
          Here's how to achieve this: Create a FormData object.
          */
          const formData = new FormData();
          /*
          Append regular fields.
          Add key-value pairs for your non-file data using formData.append(name, value).
          */
          /*
          formData.append('alt', 'Nice picture description');
           formData.append('title', 'Nice picture');
           formData.append('tags_csv', 'kopaonik,icon,marker');
           formData.append('size', '30');
           */
          formData.append('img_alt', formStateMeta.img_alt);
          formData.append('img_title', formStateMeta.img_title);
          formData.append('note', formStateMeta.note);
          formData.append('tags_csv', formStateMeta.tags_csv);
          formData.append('size', '30');
          /*
          Append file fields.
          Add files using formData.append(name, file, filename). The file argument can be a File object (from an <input type="file"> element), a Blob, or a Buffer (in Node.js). The filename argument is optional but recommended for clarity.
        */
          /*
          // Assuming 'fileInput' is an HTML <input type="file"> element
          const fileInput = document.querySelector('#myFileInput');
          if (fileInput.files.length > 0) {
            formData.append('profilePicture', fileInput.files[0], fileInput.files[0].name);
          }

          // Or using a Blob
          const jsonBlob = new Blob([JSON.stringify({someData: 'value' })], {type: 'application/json' });
          formData.append('jsonData', jsonBlob, 'data.json');
          */
          // formData.append('profilePicture', fileInput.files[0], fileInput.files[0].name);
          formData.append('uploaded_image', selectedFile, filename);
          /*
          Send the request with Axios.
          Make an Axios POST request, passing the FormData object as the data. Axios will automatically set the Content-Type header to multipart/form-data with the correct boundary.
          */
          // const api_url = _zzyourmap_urlLib.test_404();
          // const api_url = _zzyourmap_urlLib.image_library_upload_v1();
          const api_url = _zzyourmap_urlLib.image_library_upload_v3();
          axios.post(api_url, formData)
            .then(response => {
              console.log('response', response);
              console.log('Upload successful:', response.data);
              if (frfr_res_utils.is_srf(response?.data)) {
                const res_payload = frfr_res_utils.srf_extract_payload(response.data);
                //
                const img_url_rel = res_payload?.funcres?.img_url_rel;
                console.log('uploaded img_url_rel', img_url_rel);
                //
                refresh();
                clearFileInputField();
                setModeAdd(false);
                setImgSrcBlob(null);
                setUploadFetching(false);
              }
            })
            .catch(err => {
              console.error('ERROR axios upload file:', err);
            });
        }
      }
    }
  };
  //
  const handleSubmitFile = (e) => {
    e.preventDefault();
    _submit_file(e);
  };
  //
  //
  // ----- image meta ADD
  const [formStateMeta, setFormStateMeta] = useState({ ..._zzyourmap_preset_image_library_meta });
  const handleChangeFormStateMeta = (e) => {
    const target = e.target;
    const name = target.name;
    const value = target.value;
    setFormStateMeta({
      ...formStateMeta,
      [name]: value
    });
  };
  //
  const _handleTagPick = (new_tag) => {
    setFormStateMeta(state => {
      if (js_utils.is_string_not_empty(new_tag) && !(new_tag.includes(',')) && !(new_tag.includes(';')) && !(new_tag.includes(' '))) {
        let _new_tag = new_tag.trim().toLowerCase();
        const tags_arr = js_utils.string_split_to_arr_but_exclude_empty(state.tags_csv, ',')
        if (tags_arr.includes(_new_tag)) {
          // skip duplicate
        } else {
          if (js_utils.is_string_not_empty(_new_tag)) {
            tags_arr.push(_new_tag);
            tags_arr.sort();
            const updated_tags_csv = tags_arr.join(',');
            return {
              ...state,
              tags_csv: updated_tags_csv,
            };
          }
        }
      }
      // 
      return state; // return unchanged
    });
  };
  //
  const _handleTagsDelete = (target_tag) => {
    setFormStateMeta(state => {
      if (true) {
        const tags_arr = js_utils.string_split_to_arr_but_exclude_empty(state.tags_csv, ',')
        if (tags_arr.includes(target_tag)) {
          const updated_tags_arr = tags_arr.filter(tag => {
            if (tag === target_tag) {
              return false; // delete
            }
            return true; // all other stay
          });
          const updated_tags_csv = updated_tags_arr.join(',');
          return {
            ...state,
            tags_csv: updated_tags_csv,
          };
        }
      }
      // 
      return state; // return unchanged
    });
  };
  //
  //
  //
  return (
    <>
      <div>
        <div className="uu-gap-standalone-1rem"></div>
        <div className="yourmap__image-library__add-new">
          {
            uploadFetching === true && (
              <div className="yourmap__fetching-overlay"><UniSpinnerClassic />&nbsp;Uploading...</div>
            )
          }
          {
            modeAdd ? (
              <>
                <div>
                  <div className="uu-vector uu-vector--row uu-gaps-m-1rem">
                    <div className="yourmap__image-library__form-image-meta">
                      <div className="card-file-upload-widget">
                        <p className="uu-mt-0"><b>Upload new image to library</b></p>
                        <input
                          name="modalfileinput"
                          type="file"
                          accept={ACCEPT_FILE_TYPES_IMG_JPG_PNG}
                          multiple={false}
                          className="card-file-upload-widget__input"
                          ref={inputFileRef}
                          onChange={handleInputFileChange}
                        />
                        <div>
                          <FormGenerator
                            formDefinition={_zzyourmap_formDefinition_image_library_meta}
                            formState={formStateMeta}
                            formErrors={{}}
                            handleChange={handleChangeFormStateMeta}
                          />
                        </div>
                        <div>
                          <div className="yourmap__lib-tags uu-text-no-wrap">
                            {/*
                            Tags:
                            <div className="uu-vector uu-vector--row uu-vector--wrap uu-gaps-m-4px">
                              {
                                js_utils.string_split_to_arr_but_exclude_empty(formStateMeta.tags_csv, ',').map(tag => {
                                  return (
                                    <div key={tag} className="yourmap__lib-tags__tag yourmap__lib-tags__tag--added">{tag}<i onClick={() => { _handleTagsDelete(tag) }} className="fa fa-times-circle" aria-hidden="true"></i></div>
                                  );
                                })
                              }
                            </div>
                            */}
                            Pick tags:
                            <div className="uu-vector uu-vector--row uu-vector--wrap uu-gaps-m-4px">
                              {
                                tags_arr_all.map(tag => {
                                  return (
                                    <div key={tag} className="yourmap__lib-tags__tag yourmap__lib-tags__tag--pick" onClick={() => { _handleTagPick(tag) }}><i className="fa fa-plus" aria-hidden="true"></i>{tag}</div>
                                  );
                                })
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {
                      imgSrcBlob && (
                        <div className="yourmap__image-library__add-new__preview">
                          preview:
                          <UniImage src={imgSrcBlob} extraClass="yourmap__theme__image-lib-preview" />
                        </div>
                      )
                    }
                  </div>
                  <div className="uu-gap-standalone-1rem"></div>
                  <div className="uu-vector uu-vector-row uu-gaps-m-1rem">
                    <UniBtn
                      disabled={(inputFileRef.current?.files.length > 0) ? false : true}
                      inline
                      wide
                      circle_EX
                      size={16}
                      i="fa fa-upload"
                      title="Upload"
                      handleClick={handleSubmitFile}
                    />
                    <UniBtn
                      disabled={false}
                      inline
                      wide
                      outline
                      circle_EX
                      size={16}
                      i="fa fa-times"
                      title="Cancel"
                      handleClick={() => {
                        setModeAdd(false);
                        setImgSrcBlob(null);
                      }}
                    />
                  </div>
                </div>
              </>
            ) : (
              <UniBtn
                disabled={false}
                inline
                circle
                outline
                i="fa fa-plus"
                title_EX="Add new image into library"
                handleClick={() => {
                  setModeAdd(true);
                }}
              />
            )
          }
        </div>
      </div>
    </>
  );
};


// DEFAULT COMPONENT
const YourmapImageLibraryV4 = (props) => {
  const {
    route_freshness,
    setRouteFreshnesssUpdate,

    setUniModalPortableContent_3,
    setUniModalPortableClose_3,
  } = props.appPack;
  const {
    enableSelectSingular,
    enableSelectMultiple,
    enableAdminFunc,
  } = props;
  const cbDialogCancel = props.cbDialogCancel;

  const [modeAdd, setModeAdd] = useState(false);
  const [isRecycleBin, setIsRecycleBin] = useState(false);
  const [uploadFetching, setUploadFetching] = useState(false);
  const [tagsFilterObj, setTagsFilterObj] = useState({});
  const [showDetails, setShowDetails] = useState(false);
  const [dataFreshness, setDataFreshness] = useState(0);
  const dataFreshnessRefresh = () => { setDataFreshness(state => state + 1); };
  const [imageLibEntitiesDmd, setImageLibEntitiesDmd] = useState(dmd_utils.create_type_arr()); // TODO
  const [imageLibEntitiesDeletedDmd, setImageLibEntitiesDeletedDmd] = useState(dmd_utils.create_type_arr()); // TODO
  const [imageLibTagsArrAllDmd, setImageLibTagsArrAllDmd] = useState(dmd_utils.create_type_arr(..._zzyourmap_lib_image_library_tags_default)); // TODO
  const [imageLibTagsArrUsedDmd, setImageLibTagsArrUsedDmd] = useState(dmd_utils.create_type_arr(..._zzyourmap_lib_image_library_tags_default)); // TODO
  const fetching = dmd_utils.is_fetching(imageLibEntitiesDmd);
  const tags_arr_all = dmd_utils.dmd_to_always_arr(imageLibTagsArrAllDmd);
  const tags_arr_used = dmd_utils.dmd_to_always_arr(imageLibTagsArrUsedDmd);
  //
  const [selectedLibItems, setSelectedLibItems] = useState([]);
  const [selectedLibItemSingular, setSelectedLibItemSingular] = useState(null);
  const cbOnSelectionChange = (selectedRowKeys) => {
    setSelectedLibItems(selectedRowKeys);
  };
  const cbOnSelectionChangeSingular = (selectedRowSingularKey) => {
    setSelectedLibItemSingular(selectedRowSingularKey);
  };
  //
  // const cbPickSingleImage = props.cbPickSingleImage; // TODO
  const cbPickSingleImage = () => {
    if (enableSelectSingular === true && typeof props.cbPickSingleImage === 'function') {
      if (fetching !== true && selectedLibItemSingular !== null) {
        const arr_for_picking = dmd_utils.dmd_to_always_arr(imageLibEntitiesDmd);
        let bingo = false;
        let bingo_item = null;
        arr_for_picking.forEach(item => {
          if (bingo === false && item.id === selectedLibItemSingular) { // BINGO
            bingo = true; // prevent another bingo
            bingo_item = item;
            // return bingo_item;
          }
        });
        if (bingo === true && bingo_item) {
          // EXECUTE CALLBACK
          console.log('* * * caling props.cbPickSingleImage', bingo_item);
          props.cbPickSingleImage(bingo_item, 'second arg');
        }
        cbDialogCancel?.();
      }
    }
  };
  //
  const cbPickMultipleImages = () => {
    console.log('cbPickMultipleImages', cbPickMultipleImages);
    console.log('typeof props.cbPickMultipleImages', typeof props.cbPickMultipleImages);
    if (enableSelectMultiple === true && typeof props.cbPickMultipleImages === 'function') {
      let bingo_items_arr = [];
      if (fetching !== true && selectedLibItems) {
        const arr_for_picking = dmd_utils.dmd_to_always_arr(imageLibEntitiesDmd);
        // let bingo = false;
        let bingo_item = null;
        arr_for_picking.forEach(item => {
          if (selectedLibItems.includes(item.id)) { // BINGO
            // bingo = true; // prevent another bingo
            bingo_item = item;
            // return bingo_item;
            bingo_items_arr.push(item);
          }
        });
        if (true) {
          // EXECUTE CALLBACK
          console.log('* * * caling props.cbPickMultipleImages', bingo_items_arr);
          props.cbPickMultipleImages(bingo_items_arr, 'second arg');
        }
        cbDialogCancel?.();
      }
    }
  };

  const refresh = () => {
    // resetSelection();
    /*
    const api_url = _zzyourmap_urlLib.image_lib_get_all();
    axios.post(api_url, formData)
    */
    setImageLibEntitiesDmd(state => dmd_utils.update_fetching(state, true));
    setImageLibEntitiesDeletedDmd(state => dmd_utils.update_fetching(state, true));
    dataFreshnessRefresh();
    _zzyourmap_ajax.image_lib_get_all()
      .then(response => {
        console.log('response', response);
        if (frfr_res_utils.is_srf(response?.data)) {
          const res_payload = frfr_res_utils.srf_extract_payload(response.data);
          //
          // const rows = res_payload?.funcres?.$dbres?.rows;
          const rows = res_payload?.rows;
          if (Array.isArray(rows)) {
            const [entities, entities_deleted, tags_arr_all, tags_arr_used] = _zzyourmap_prepare_image_library_entities(rows);
            console.log('image library entities_deleted', entities_deleted);
            // setImageLibEntitiesDmd(entities);
            setImageLibEntitiesDmd(state => dmd_utils.update_arr(state, entities, false));
            setImageLibEntitiesDeletedDmd(state => dmd_utils.update_arr(state, entities_deleted, false));
            setImageLibTagsArrAllDmd(state => dmd_utils.update_arr(state, tags_arr_all, false));
            setImageLibTagsArrUsedDmd(state => dmd_utils.update_arr(state, tags_arr_used, false));
            dataFreshnessRefresh();
          }
        }
      })
      .catch(err => {
        console.error('ERROR image_lib_get_all', err);
        dataFreshnessRefresh();
      });

  };
  //
  /*
  useEffect(() => {
    refresh();
  }, []);
  */
  useEffect(() => { // REFRESH BY ROUTE (or refresh once on mount)
    refresh();
  }, [route_freshness]);

  //
  useEffect(() => { // reset tags filters on tag list change
    setTagsFilterObj({});
  }, [tags_arr_used]);
  // Tag filter
  const _handleChangeTagsFilter = (tag) => {
    setTagsFilterObj(tagsFilterObj => {
      const updated_tags_filter = { ...tagsFilterObj };
      if (updated_tags_filter[tag] === true) {
        delete updated_tags_filter[tag];
      } else {
        updated_tags_filter[tag] = true;
      }
      return updated_tags_filter;
    });
    // dataFreshnessRefresh();
  };
  //
  useEffect(() => {
    dataFreshnessRefresh();
  }, [tagsFilterObj]);

  //
  const _handleClickDeleteImage = (item_key) => {
    if (item_key > 0) {
      // const api_url = _zzyourmap_urlLib.image_lib_update_flagdeleted(item_key);
      _zzyourmap_ajax.image_lib_update_flagdeleted({ flag_deleted: true }, item_key)
        .then(response => {
          console.log('response', response);
          console.log('image_lib_update_flagdeleted successful:', response.data);
          if (frfr_res_utils.is_srf(response?.data)) {
            const res_payload = frfr_res_utils.srf_extract_payload(response.data);
            //
            console.log('res_payload', res_payload);
            //
            refresh();
          }
        })
        .catch(err => {
          console.error('ERROR axios image_lib_update_flagdeleted:', err);
        });
    }
  };

  // TODO
  const _handleClickUndeleteImage = (item_key) => {
    if (item_key > 0) {
      // const api_url = _zzyourmap_urlLib.image_lib_update_undelete(item_key);
      _zzyourmap_ajax.image_lib_update_undelete({ flag_deleted: false }, item_key)
        .then(response => {
          console.log('response', response);
          console.log('image_lib_update_undelete successful:', response.data);
          if (frfr_res_utils.is_srf(response?.data)) {
            const res_payload = frfr_res_utils.srf_extract_payload(response.data);
            //
            console.log('res_payload', res_payload);
            //
            refresh();
          }
        })
        .catch(err => {
          console.error('ERROR axios image_lib_update_undelete:', err);
        });
    }
  };

  //
  const cbSubmitUpdateImageMeta = (entbox, payload) => {
    console.log('SUBMIT UPDATE cbSubmitUpdateImageMeta entbox payload', entbox, payload);
    const id = payload.id;
    if (id > 0) {
      // const api_url = _zzyourmap_urlLib.image_lib_update_meta(item_key);
      _zzyourmap_ajax.image_lib_update_meta(entbox, id)
        .then(response => {
          console.log('response', response);
          console.log('image_lib_update_meta successful:', response.data);
          if (frfr_res_utils.is_srf(response?.data)) {
            const res_payload = frfr_res_utils.srf_extract_payload(response.data);
            //
            console.log('res_payload', res_payload);
            //
            refresh();
            setUniModalPortableClose_3(); // TODO
          }
        })
        .catch(err => {
          console.error('ERROR axios image_lib_update_meta:', err);
        });
    }
  };

  //
  //
  //
  // let _selected_src = '/static/img/frfr-image-placeholder-xgradient-1024x1024px.png';
  /*
  const resetSelection = () => {
            setSelectedLibItems(state => {
              return [];
            });
          setSelectedLibItemSingular(null);
  };
          */

  let jsxSpinner = null;
  /*
  if (fetching) {
    jsxSpinner = (
      <UniSpinnerClassic />
    );
  }
  */
  let arr = [];
  if (false) {
    arr = rapidozi_dummysmarty_utils.multiplicate_entities([
      { img_url_full: '/static/img/frfr-image-placeholder-xgradient-1024x1024px.png', },
      { img_url_full: '/static/img/banner-placeholder-250x250.png', },
      { img_url_full: '/static/img/photoshop-checkboard-pattern-20px.png', },
    ], 3);
  }
  arr = dmd_utils.dmd_to_always_arr(imageLibEntitiesDmd);
  if (isRecycleBin === true) {
    arr = dmd_utils.dmd_to_always_arr(imageLibEntitiesDeletedDmd);
  }
  //
  //
  const filtered_arr = arr.filter((item) => {
    if (Object.keys(tagsFilterObj).length === 0) { // CASE no filter everihingy stay
      return true; // stay
    } else {
      if (js_utils.is_string_not_empty(item.tags_csv)) { // CASE itam has tags
        // CASE filter by tags
        let _in = true;
        Object.keys(tagsFilterObj).forEach(tag => {
          if (tag === 'UNTAGGED') { // CASE exclude beacuse requirement is to have zero tags
            _in = false; // exclude
          } else {
            if (item.tags_csv.includes(tag)) { // CASE can stay for now
            } else { // CASE not contain required tag
              _in = false; // exclude
            }
          }
          if (tagsFilterObj['UNTAGGED'] === true) { // CASE exclude beacuse requirement is to have zero tags
            _in = false; // exclude
          }
        });
        return _in;
      } else { // CASE item zero tags
        if (tagsFilterObj['UNTAGGED'] === true) {
          if (Object.keys(tagsFilterObj).length > 1) {
            return false; // exclude
          } else {
            return true; // stay
          }
        } else {
          return false;
        }
      }
    }
  });

  //
  //
  //
  const viewArgs = {
    _fetching: fetching,
    // _viewBlueprint,
    // rowsData: arr,
    rowsData: filtered_arr,
    dataFreshness,
    cbOnSelectionChange,
    cbOnSelectionChangeSingular,
  };
  //
  return (
    <>
      <div className="yourmap__image-library">
        <h2 className="uu-mt-0">Image Library</h2>
        <div className="yourmap__article__title-and-subtitle">
          <p><b>Select existing image (or upload new ...then select)</b></p>
        </div>

        {/* IMAGE LIBRARY SIDEBAR FILTERS... */}
        <div className="uu-vector uu-vector--row">
          <div className="uu-vector uu-vector--col uu-gaps-p-05rem">
            {
              enableAdminFunc === true && (
                <div className="xi">
                  <div className="yourmap__card yourmap__card--pad-05rem uu-shadow-alien-fluent2-tile-shadow uu-text-nowrap">
                    <FormFieldGenerator
                      fieldDefinition={{
                        "type": "input_radio_group",
                        "params": {
                          "label": null,
                          "name": "isRecycleBin",
                          "options": [
                            { "title": "Redovno", "value": "" },
                            { "title": "Recycle bin", "value": "RECYCLE_BIN" },
                          ],
                          "style_row": false,
                          "style_outline": false,
                        }
                      }}
                      value={isRecycleBin === true ? "RECYCLE_BIN" : ""}
                      handleChange={(e) => {
                        if (e.target.value === "RECYCLE_BIN") {
                          setIsRecycleBin(true);
                        } else {
                          setIsRecycleBin(false);
                        }
                      }}
                      fieldError={null}
                    />
                  </div>
                </div>
              )
            }
            <div className="xi">
              <div className="yourmap__card yourmap__card--pad-05rem uu-shadow-alien-fluent2-tile-shadow uu-text-nowrap">
                <FormFieldGenerator
                  fieldDefinition={{
                    "type": "input_checkbox",
                    "params": {
                      "label": 'Show details',
                      "name": 'showDetails',
                      // "extraclass": "novo-radios-row",
                      "style_row": true,
                      "style_outline": false,
                    }
                  }}
                  value={showDetails}
                  handleChange={(e) => { setShowDetails(showDetails => !showDetails); }}
                  fieldError={null}
                />
              </div>
            </div>
            <div className="xi">
              <div className="yourmap__card yourmap__card--pad-05rem uu-shadow-alien-fluent2-tile-shadow uu-text-nowrap yourmap__image-library__tags-filter">
                <div><b>Filter by tags</b></div>
                {
                  tags_arr_used.map(tag => {
                    return (
                      <FormFieldGenerator
                        key={tag}
                        fieldDefinition={{
                          "type": "input_checkbox",
                          "params": {
                            "label": tag,
                            "name": tag,
                            // "extraclass": "novo-radios-row",
                            "style_row": true,
                            "style_outline": false,
                          }
                        }}
                        value={tagsFilterObj?.[tag] === true}
                        handleChange={(e) => { _handleChangeTagsFilter(e.target.name); }}
                        fieldError={null}
                      />
                    );
                  })
                }
                <FormFieldGenerator
                  fieldDefinition={{
                    "type": "input_checkbox",
                    "params": {
                      "label": '* UNTAGGED',
                      "name": 'UNTAGGED',
                      // "extraclass": "novo-radios-row",
                      "style_row": true,
                      "style_outline": false,
                    }
                  }}
                  value={tagsFilterObj?.['UNTAGGED'] === true}
                  handleChange={(e) => { _handleChangeTagsFilter('UNTAGGED'); }}
                  fieldError={null}
                />
              </div>
            </div>
          </div>
          <div className="uu-gap-standalone-1rem"></div>
          <div>
            {jsxSpinner}
            <div>
              <ImageLibraryView
                viewArgs={viewArgs}
                tags_arr_all={tags_arr_all}
                tags_arr_used={tags_arr_used}
                enableSelectSingular={enableSelectSingular}
                enableSelectMultiple={enableSelectMultiple}
                enableAdminFunc={enableAdminFunc}
                isRecycleBin={isRecycleBin}
                showDetails={showDetails}
                _handleClickDeleteImage={_handleClickDeleteImage}
                _handleClickUndeleteImage={_handleClickUndeleteImage}
                cbSubmitUpdateImageMeta={cbSubmitUpdateImageMeta}
                setUniModalPortableContent_3={setUniModalPortableContent_3}
                setUniModalPortableClose_3={setUniModalPortableClose_3}
              />
            </div>
          </div>
        </div>

        <FormAddToImageLibrary
          appPack={props.appPack}
          modeAdd={modeAdd}
          setModeAdd={setModeAdd}
          uploadFetching={uploadFetching}
          setUploadFetching={setUploadFetching}
          refresh={refresh}
          tags_arr_all={tags_arr_all}
        />

        <div>
          <div className="uu-gap-standalone-1rem"></div>
          <div className="uu-vector uu-vector--col uu-gaps-p-05rem">
            <div className="uu-vector uu-vector--row uu-gaps-m-05rem">
              <UniBtn
                disabled_EX={selectedLibItems.length > 0 ? false : true}
                disabled={(enableSelectSingular === true && selectedLibItemSingular !== null) || (enableSelectMultiple === true && selectedLibItems.length > 0) ? false : true}
                inline
                circle
                wide
                i="fa fa-check"
                title="Pick selected image"
                handleClick={() => {
                  if (typeof cbPickSingleImage === 'function') {
                    cbPickSingleImage();
                  }
                  if (typeof cbPickMultipleImages === 'function') {
                    cbPickMultipleImages();
                  }
                }}
              />
              <UniBtn
                disabled={false}
                inline
                circle
                i="fa fa-refresh"
                title_EX="Refresh"
                handleClick={() => { refresh(); }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default YourmapImageLibraryV4;